// extracted by mini-css-extract-plugin
export default {"factory":"FactoryIllustration_factory__NHtAs"};